import { Category } from "../models/category";
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface putStorePageParams {
    current?: number;
    size?: number;
    allNum?: string;
    storehouseId?: number;
    storehouseTag?: string;
    recepitsDateEnd?: string;
    recepitsDateStart?: string;
    departmentId?: string;
    userId?: string;
    supplierId?: string;
    category?: Category;
    registrationTimeHead?: string;
    registrationTimeTail?: string;
}

export interface putStorageparams {
    acceptStorehouseId?: number,
    acceptStorehouseName?: string,
    flag?: number,
    category?: Category;
    departmentId?: number;
    departmentName?: string;
    id?: number;
    putNumber?: string;
    realPayMoney?: number;
    recepitsDate?: string;
    recepitsNumber?: string;
    remark?: string;
    shouldPayMoney?: number;
    status?: number;
    storehouseId?: number;
    storehouseName?: string;
    storehouseTag?: number;
    supplierId?: number;
    supplierName?: string;
    tenantId?: number;
    userId?: number;
    userName?: string;
}

export function putstoragePage(
    params: putStorePageParams
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryreceipts/page`,
        method: "GET",
        params
    }
}

export function putlistDetail(
    putNumber: number
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryreceipts/detailputnumber`,
        method: 'GET',
        params: {
            putNumber
        }
    }
}

export function putstorageDetail(
    id: number
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryreceiptsitem/list`,
        method: "GET",
        params: {
            tenantInventoryReceiptsId: id
        }
    }
}

export function putstorageSave(
    params: putStorageparams
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryreceipts/submit`,
        method: "POST",
        body: params
    }
}
export function putstorageUpdata(
    params: putStorageparams
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryreceipts/submit`,
        method: "POST",
        body: params
    }
}

export function putstorageSavelist(
    id: string
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryledger/upaccount`,
        method: "POST",
        params: {
            tenantInventoryReceiptsIds: id
        }
    }
}

export function putstorageRect(
    id: string
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryledger/upreverse`,
        method: "POST",
        params: {
            tenantInventoryReceiptsIds: id
        }
    }
}

export function putstorageFinish(
    id: number
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryreceipts/finish`,
        method: "GET",
        params: {
            id
        }
    }
}